__turbopack_context__.v({
  "actions": "PerformanceLabLeadFormSection-module__1YJOmq__actions",
  "consent": "PerformanceLabLeadFormSection-module__1YJOmq__consent",
  "consentBox": "PerformanceLabLeadFormSection-module__1YJOmq__consentBox",
  "field": "PerformanceLabLeadFormSection-module__1YJOmq__field",
  "fieldRow": "PerformanceLabLeadFormSection-module__1YJOmq__fieldRow",
  "form": "PerformanceLabLeadFormSection-module__1YJOmq__form",
  "formMessage": "PerformanceLabLeadFormSection-module__1YJOmq__formMessage",
  "fullWidthCTA": "PerformanceLabLeadFormSection-module__1YJOmq__fullWidthCTA",
  "hiddenLabel": "PerformanceLabLeadFormSection-module__1YJOmq__hiddenLabel",
  "honeypot": "PerformanceLabLeadFormSection-module__1YJOmq__honeypot",
  "input": "PerformanceLabLeadFormSection-module__1YJOmq__input",
  "introColumn": "PerformanceLabLeadFormSection-module__1YJOmq__introColumn",
  "introHeading": "PerformanceLabLeadFormSection-module__1YJOmq__introHeading",
  "shell": "PerformanceLabLeadFormSection-module__1YJOmq__shell",
});
